/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/settings
 */
import { default as DefaultIcon } from '~icons/lucide/settings';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const SettingsIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
